import React from "react";

import PaxIcon from "../images/pax.svg";
import LugIcon from "../images/suitcase.svg";
import { getRequests, postRequest } from "../helpers/ApiHelper";
import QuoteInfo from "../components/QuoteInfo.js";
import { withRouter } from "react-router-dom";
class Fleet extends React.Component {
  maxFleet = 10;
  quoteLoading = true;
  quoteFleetLoading = true;
  constructor(props) {
    super(props);
    this.state = {
      quote: {},
      fleets: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const quoteId = localStorage.getItem("quoteId");
    if (quoteId !== undefined) {
      getRequests("quote/" + quoteId).then((data) => {
        this.quoteLoading = false;
        this.handleChange({
          quote: data,
        });
      });
      getRequests("quote/" + quoteId + "/fleets").then((fleetData) => {
        this.quoteFleetLoading = false;
        fleetData.forEach((single) => {
          if (single.fleet_count > 1) {
            single.total = single.fare_data.one_way_total * single.fleet_count;
          }else{
            single.total = single.fare_data.one_way_total;
          }
          single.trip_type = "one_way";
        });
        this.handleChange({
          fleets: fleetData,
        });
      });
    }
  }

  handleChange(changeObject) {
    this.setState(changeObject);
  }
  fleetSelected(fleet) {
    localStorage.setItem("quoteFleetId", fleet.id);
    const data = {
      fleet_count: fleet.fleet_count,
      trip_type: this.state.quote.trip_type,
    };
    postRequest("quote-fleet-update/" + fleet.id, data).then(
      (res) => {
        this.props.history.push("/book-passenger");
      },
      (error) => {}
    );
  }
  tripTypeChanged(fleet, event) {
    const data = event.target.value;
    const Fleets = this.state.fleets;
    const quote = this.state.quote;
    quote.trip_type = data;
    Fleets.forEach((fleetSingle) => {
      if (fleetSingle.id === fleet.id) {
        if (fleet.trip_type !== data) {
          let total;
          if (data === "round_trip") {
            total = fleetSingle.fare_data.one_way_total + fleetSingle.fare_data.return_total;
          } else {
            total = fleetSingle.fare_data.one_way_total;
          }
          fleetSingle.total = total;
        }
        fleet.trip_type = data;
      }
    });

    this.handleChange({
      fleets: Fleets,
      quote: quote,
    });
  }
  fleetCountChange(event, fleet) {
    const data = event.target.value;
    const Fleets = this.state.fleets;
    Fleets.forEach((fleetSingle) => {
      if (fleetSingle.id === fleet.id) {
        let total = fleet.total;
        if (fleetSingle.fleet_count) {
          total = total / fleetSingle.fleet_count;
        }
        fleetSingle.total = parseInt(data) * total;
        fleetSingle.fleet_count = data;
      }
    });
    this.handleChange({
      fleets: Fleets,
    });
  }

  render() {
    return (
      <section className="booking-flow-wrapper section-gap ">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="booking-sidebar-wrapper">
                <h4>Booking Information</h4>
                {this.quoteLoading && (
                  <div className="loader-wrapper">
                    <div className="  loader">
                      <span>L</span>
                      <span>o</span>
                      <span>a</span>
                      <span>d</span>
                      <span>i</span>
                      <span>n</span>
                      <span>g</span>
                    </div>
                  </div>
                )}
                {!this.quoteLoading && (
                  <QuoteInfo quoteData={this.state.quote} />
                )}
              </div>
            </div>
            <div className="col-md-8">
              {this.quoteFleetLoading && (
                <div className="loader-wrapper">
                  <div className="  loader">
                    <span>L</span>
                    <span>o</span>
                    <span>a</span>
                    <span>d</span>
                    <span>i</span>
                    <span>n</span>
                    <span>g</span>
                  </div>
                </div>
              )}
              {!this.quoteFleetLoading && (
                <div>
                  {this.state.fleets.map((fleet, index) => (
                    <div key={index} className="single-vehicle">
                      <div className="row">
                        <div className="col-md-5">
                          <img className="mb-4" alt="" src={fleet.image_path} />
                          <div className="vehicle-info">
                            <span>
                              <img src={PaxIcon} alt="" />
                              {fleet.max_passenger} Max
                            </span>
                            <span>
                              <img src={LugIcon} alt="" />
                              {fleet.max_suitcase} Max
                            </span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <h3> {fleet.name}</h3>
                          {fleet.info1 && (
                            <p className="badge ">{fleet.info1}</p>
                          )}
                          {fleet.info2 && (
                            <p className="badge ">{fleet.info2}</p>
                          )}
                          {fleet.info3 && (
                            <p className="badge ">{fleet.info3}</p>
                          )}
                          {fleet.info4 && (
                            <p className="badge ">{fleet.info4}</p>
                          )}
                        </div>
                        <div className="col-md-3 price-wrapper">
                          <h4>${fleet.total.toFixed(2)}</h4>
                          <input
                            type="radio"
                            id={"one-way-trip" + fleet.id}
                            name={"radio-group" + fleet.id}
                            required
                            value={"one_way"}
                            checked={fleet.trip_type === "one_way"}
                            onChange={(e) => {
                              this.tripTypeChanged(fleet, e);
                            }}
                          />
                          <label htmlFor={"one-way-trip" + fleet.id}>
                            &nbsp;&nbsp;One Way
                          </label>
                          <br />
                          <input
                            type="radio"
                            id={"two-way-trip" + fleet.id}
                            name={"radio-group" + fleet.id}
                            value={"round_trip"}
                            checked={fleet.trip_type === "round_trip"}
                            onChange={(e) => {
                              this.tripTypeChanged(fleet, e);
                            }}
                          />
                          <label htmlFor={"two-way-trip" + fleet.id}>
                            &nbsp;&nbsp;Two Way
                          </label>
                          <hr />
                          <p className="mt-2 mb-1">No. of Vehicle</p>
                          <select
                            className="form-control mb-2"
                            onChange={(e) => this.fleetCountChange(e, fleet)}
                            value={fleet.fleet_count}
                          >
                            {[...Array(this.maxFleet).keys()].map(
                              (number, key) => {
                                return (
                                  <option key={key} value={number + 1}>
                                    {number + 1}
                                  </option>
                                );
                              }
                            )}
                          </select>
                          <button
                            className="btn btn-yellow btn-block"
                            onClick={() => this.fleetSelected(fleet)}
                          >
                            Select
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default withRouter(Fleet);
